import { User } from "@/models/User"

import { Notification } from "./Notification"

import type { CalendarNotificationEvent } from "./NotificationCalendar"

interface TimeOffImpactEntryContent {
  departingUser?: Partial<User>
  note?: string
  startDate: string
  endDate: string
}

interface TimeOffImpactNotificationContent {
  finalNotice?: boolean
  startsToday?: boolean
  entries?: TimeOffImpactEntryContent[]
}

/**
 * Normalizes the time-off impact payload and groups members sharing the same event into one UI row.
 * The backend sends one entry per departing member even when they belong to the same calendar event.
 */
export class NotificationTimeOffImpact extends Notification {
  get content(): TimeOffImpactNotificationContent {
    return super.content as TimeOffImpactNotificationContent
  }

  get finalNotice(): boolean {
    return this.content.finalNotice ?? false
  }

  get startsToday(): boolean {
    return this.content.startsToday ?? false
  }

  get events(): CalendarNotificationEvent[] {
    const events = new Map<string, CalendarNotificationEvent>()

    for (const entry of this.content.entries ?? []) {
      const eventKey = [entry.note, entry.startDate, entry.endDate].join("|")
      const event = events.get(eventKey)
      const departingUser = entry.departingUser ? new User(entry.departingUser) : undefined

      if (event) {
        if (departingUser) event.users.push(departingUser)
        continue
      }

      events.set(eventKey, {
        id: eventKey,
        type: "TIME_OFF",
        description: entry.note || "Time Off",
        startDate: entry.startDate,
        endDate: entry.endDate,
        allDay: true,
        users: departingUser ? [departingUser] : []
      })
    }

    return Array.from(events.values())
  }
}
